import {
    Database,
    Bot,
    Workflow,
    BarChart3,
    BrainCircuit,
    Layers3,
    XCircle,
    CheckCircle2,
} from "lucide-react";

import { SectionHeading } from "@/components/common/SectionHeading";

const columns = [
    {
        title: "Traditional Software",

        subtitle: "Disconnected tools",

        color: "text-red-500",

        icon: XCircle,

        features: [

            "Manual data entry",

            "Spreadsheet-based reporting",

            "Disconnected applications",

            "Reactive decision making",

            "Limited integrations",

            "No intelligent automation",

        ],
    },

    {
        title: "Generic SaaS",

        subtitle: "One-size-fits-all",

        color: "text-amber-500",

        icon: Layers3,

        features: [

            "Quick deployment",

            "Standard workflows",

            "Basic reporting",

            "Limited customisation",

            "Subscription pricing",

            "Restricted integrations",

        ],
    },

    {
        title: "VibeWell AI Platform",

        subtitle: "Business-first intelligence",

        color: "text-primary",

        icon: BrainCircuit,

        features: [

            "AI-powered automation",

            "Predictive insights",

            "Workflow intelligence",

            "Enterprise integration",

            "Real-time dashboards",

            "Business-specific solutions",

            "Cloud-native architecture",

            "Scalable digital transformation",

        ],
    },
];

export default function PlatformComparison() {

    return (

        <section className="py-24">

            <div className="mx-auto max-w-7xl px-6">

                <SectionHeading

                    eyebrow="Platform Comparison"

                    title="Traditional Software vs Intelligent Business Platform"

                    description="Move beyond disconnected applications and manual processes with an AI-powered enterprise platform."

                />

                <div className="mt-14 grid gap-8 lg:grid-cols-3">

                    {columns.map((column) => {

                        const Icon = column.icon;

                        return (

                            <div
                                key={column.title}
                                className="rounded-3xl border bg-card p-8 shadow-sm"
                            >

                                <Icon
                                    className={`h-9 w-9 ${column.color}`}
                                />

                                <h3 className="mt-6 text-2xl font-semibold">

                                    {column.title}

                                </h3>

                                <p className="mt-2 text-muted-foreground">

                                    {column.subtitle}

                                </p>

                                <div className="mt-8 space-y-4">

                                    {column.features.map((feature) => (

                                        <div
                                            key={feature}
                                            className="flex gap-3"
                                        >

                                            <CheckCircle2 className="mt-1 h-5 w-5 text-primary"/>

                                            <span>

                                                {feature}

                                            </span>

                                        </div>

                                    ))}

                                </div>

                            </div>

                        );

                    })}

                </div>

            </div>

        </section>

    );

}